import { useQuery } from '@tanstack/react-query'

import { getFreeeSyncStatus } from '@src/api'
import { DefaultApiGetFreeeSyncStatusRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFreeeSyncStatus = (
  params: DefaultApiGetFreeeSyncStatusRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: params.organizationId !== undefined,
    queryFn: () => getFreeeSyncStatus(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_FREEE_SYNC_STATUS,
      params.organizationId,
    ],
    staleTime: 0,
  })
}
